import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { MotifTabNavigation, MotifTabControl } from '@ey-xd/motif-react';
import { Link } from 'react-router';
import { reduxForm, getFormValues, reset } from 'redux-form';
import { withRouter } from '../../common/withRouter';
import OwnershipHeader from '../../components/bulkPeriodManagement/OwnershipHeader';
import * as periodActions from '../../actions/periodActions';
import * as propertyActions from '../../actions/propertyActions';
import OwnershipTable from '../../components/bulkPeriodManagement/OwnershipTable';
import { store } from '../../store/configureStore';
import UploadOwnershipModal from '../../components/bulkPeriodManagement/UploadOwnershipModal';
import ReportPeriodComparator from '../../components/shared/customComparators/ReportPeriodComparator';
/**
 * MasterDataManagementTRSContainer component
 * @extends {React.Component}
 */
class OwnershipContainer extends Component {
  /**
   * Creates a new MasterDataManagementTRSContainer
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);
    this.handleGridChanges = this.handleGridChanges.bind(this);
    this.setGridColumnState = this.setGridColumnState.bind(this);
    this.handleGridColumnStateChange =
      this.handleGridColumnStateChange.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleUploadOwnershipImportTemplate =
      this.handleUploadOwnershipImportTemplate.bind(this);
    this.handleExportOwnershipImportTemplate =
      this.handleExportOwnershipImportTemplate.bind(this);
    this.handleEditOwnershipPercentage =
      this.handleEditOwnershipPercentage.bind(this);
    this.toggleGridEditMode = this.toggleGridEditMode.bind(this);
    this.state = {
      gridCurrentState: [],
      gridColumnState: [],
      periods: [],
      ownershipData: [],
      selectedReportPeriod: null,
      reportPeriodOptions: [],
      disableAction: false,
      showUploadOwnershipModal: false,
      isEditModeActive: false,
      gridDataAfterAction: [],
      defaultReportPeriod: null,
      selectedCalendarYear: null,
      resetUpdatedRowDataTrigger: 0,
      reportPeriodId: 0,
    };
  }

  /**
   * Invoked immediately after mounting occurs
   * @returns {undefined}
   */
  componentDidMount() {
    this.fetchReportPeriodsByClientId();
  }

  componentDidUpdate(prevProps) {
    // Check if ownershipFormValues have changed
    if (prevProps.ownershipFormValues !== this.props.ownershipFormValues) {
      const { reportPeriod } = this.props.ownershipFormValues || {};
      if (reportPeriod) {
        this.setState({ selectedReportPeriod: reportPeriod });
        // Fetch Ownership data for the client and report period
        this.props.propertyActions.fetchOwnershipDataByPeriod(
          this.props.clientId,
          reportPeriod
        );
      }
    }
    if (
      this.props.ownershipData &&
      this.props.ownershipData !== prevProps.ownershipData
    ) {
      const hasPropertyData = this.props.ownershipData?.some(
        (row) => row.propertyName && row.propertyTrackingID
      );
      this.setState({
        ownershipData: this.props.ownershipData,
        disableAction: hasPropertyData, // Set actionValue based on property data presence
      });
    }
  }

  componentWillUnmount() {
    this.setState({
      periods: [],
      ownershipData: [],
    });
  }

  //Set tab related state variables
  setActiveTab(currentIndex) {
    this.setState({ tabBar1: currentIndex });
  }

  //Set current tab index based
  handleTabClick(index) {
    this.setActiveTab(index);
  }

  /**
   * Set AG-Grid column state
   * @returns {undefined}
   */
  setGridColumnState() {
    var columnState = localStorage.getItem('REITSuiteOwnershipColumnState');
    if (columnState) {
      this.setState({ gridColumnState: JSON.parse(columnState) });
    } else {
      this.setState({ gridColumnState: [{ colId: '-1' }] });
    }
  }

  fetchReportPeriodsByClientId() {
    this.props.periodActions
      .fetchReportPeriodsByClientId(this.props.clientId)
      .then((periods) => {
        if (!periods || periods.length === 0) {
          return;
        }
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        const uniqueDescriptions = [
          ...new Set(
            periods
              .filter((p) => p.reportPeriodDescription)
              .map((p) => p.reportPeriodDescription)
          ),
        ];

        const sortedPeriods = uniqueDescriptions.sort(ReportPeriodComparator);

        const currentQuarter = `Q${Math.ceil((currentDate.getMonth() + 1) / 3)} ${currentYear}`;
        const defaultReportPeriod =
          sortedPeriods.find((p) => p === currentQuarter) ||
          sortedPeriods[0] ||
          null;
        const selectedPeriod = periods.find(
          (p) => p.reportPeriodDescription === defaultReportPeriod
        );
        const reportPeriodId = selectedPeriod
          ? selectedPeriod.reportPeriodID
          : 0;
        this.setState(
          {
            periods,
            reportPeriods: sortedPeriods,
            defaultReportPeriod,
            reportPeriodId: reportPeriodId,
          },
          () => this.handleReportPeriodSelection(defaultReportPeriod)
        );
      });
  }

  handleReportPeriodSelection = (reportPeriod) => {
    // Extract quarter and year from report period string (format: "Q1 2023")
    const parts = reportPeriod.split(' ');
    const quarter = parts[0]; // e.g., "Q1"
    const year = parseInt(parts[1]); // e.g., 2023

    const selectedPeriod = this.state.periods.find(
      (p) => p.reportPeriodDescription === reportPeriod
    );

    const reportPeriodId = selectedPeriod ? selectedPeriod.reportPeriodID : 0;

    this.setState(
      {
        selectedQuarter: quarter,
        selectedCalendarYear: year,
        defaultReportPeriod: reportPeriod,
        isEditModeActive: false,
        reportPeriodId: reportPeriodId,
      },
      this.getOwnershipGridGridData
    );
  };

  getOwnershipGridGridData() {
    this.props.propertyActions
      .fetchOwnershipDataByPeriod(
        this.props.clientId,
        this.state.defaultReportPeriod
      )
      .then(() => {
        this.setState({
          bulkProcessManagementData: this.props.bulkProcessManagementData,
        });
      });
  }

  /**
   * Handle Grid column state chagne
   * @returns {undefined}
   */
  handleGridColumnStateChange(columnState) {
    this.setState({ gridColumnState: columnState });
  }

  handleGridChanges(gridRowData) {
    const rowData =
      gridRowData &&
      gridRowData.length &&
      gridRowData.map((x) => {
        return {
          propertyID: x.propertyID,
          reitTrackingID: x.reitTrackingID,
          reitName: x.reitName,
          propertyName: x.propertyName,
          propertyTrackingID: x.propertyTrackingID,
          percentageOfOwnership: x.percentageOfOwnership,
          propertyTypeDescription: x.propertyTypeDescription,
        };
      });

    this.setState({ gridCurrentState: rowData });
  }

  getOwnershipGridData(clientId, reportPeriodID) {
    // Fetching the data for the grid
    this.props.propertyActions.fetchOwnershipDataByPeriod(
      clientId,
      reportPeriodID
    );
  }

  handleExportOwnershipImportTemplate() {
    this.props.propertyActions.exportOwnershipData(
      this.props.clientId,
      this.state.defaultReportPeriod
    );
  }

  resetForm() {
    store.dispatch(reset('ownershipForm'));
  }

  handleUploadOwnershipImportTemplate() {
    this.setState({ showUploadOwnershipModal: true, isEditModeActive: false });
  }

  toggleUploadOwnershipModal = () => {
    this.setState({
      showUploadOwnershipModal: !this.state.showUploadOwnershipModal,
      isEditModeActive: false,
    });
    this.props.propertyActions.fetchOwnershipDataByPeriod(
      this.props.clientId,
      this.state.defaultReportPeriod
    );
  };

  /**
   * Activates edit mode for Owneship% .
   * This method updates the component's state by setting `isEditModeActive` to `true`,
   * allowing for modifications to the Owneship%.
   */
  handleEditOwnershipPercentage() {
    // Cache the original ownership data before any edits
    this.originalOwnershipData = structuredClone(this.props.ownershipData);
    this.setState({
      isEditModeActive: true,
      resetUpdatedRowDataTrigger: Date.now(),
      gridDataAfterAction: [...this.props.ownershipData],
    });
  }

  /**
   * Toggles the edit mode for the grid.
   * This method updates the component's state by switching the `isEditModeActive` value
   * between `true` and `false`, enabling or disabling edit functionality dynamically.
   */
  toggleGridEditMode(action, gridApi) {
    if (action === 'save') {
      const displayedData = [];

      if (gridApi) {
        gridApi.forEachNodeAfterFilterAndSort((node) => {
          displayedData.push(node.data); // Collect displayed row data
        });
      }

      const finalOwnershipPercentageList = displayedData.filter(
        (item) => item.propertyID
      );
      this.props.propertyActions
        .updatePercentageOfOwnership(finalOwnershipPercentageList)
        .then(() => {
          this.setState({
            isEditModeActive: false,
            gridDataAfterAction: [...this.props.ownershipData],
            resetUpdatedRowDataTrigger: Date.now(),
          });
          this.props.propertyActions.fetchOwnershipDataByPeriod(
            this.props.clientId,
            this.state.defaultReportPeriod
          );
        });
    } else if (action === 'cancel') {
      this.setState({
        isEditModeActive: false,
        gridDataAfterAction: [...this.props.ownershipData],
        resetUpdatedRowDataTrigger: Date.now(),
      });
    }
  }

  render() {
    const noData = !this.props.ownershipData?.length;
    const noReit = !this.state.reportPeriods?.length;
    return (
      <div>
        <h2>Bulk Period Management</h2>
        <MotifTabNavigation variant="default">
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbNewPeriod"
              onClick={() => this.handleTabClick(1)}
            >
              New Period
            </MotifTabControl>
          </Link>
          {/* Conditional rendering for Services Scope tab */}
          {!this.props.isAudit ? (
            <Link
              to={`/client/${this.props.clientId}/bulkPeriodManagement/servicesScope`}
              tabIndex="-1"
            >
              <MotifTabControl
                role="tab"
                data-testid="tbServicesScope"
                onClick={() => this.handleTabClick(2)}
              >
                Services Scope
              </MotifTabControl>
            </Link>
          ) : (
            <></> // Return an empty fragment instead of null
          )}
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement/ownership`}
            tabIndex="-1"
          >
            <MotifTabControl
              className="motif-active"
              role="tab"
              aria-selected="true"
              data-testid="tbOwnership%"
              onClick={() => this.handleTabClick(3)}
            >
              Ownership %
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement/tenantServicesAmenities`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbTenantServices"
              onClick={() => this.handleTabClick(4)}
            >
              Tenant Services / Amenities
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement/signOff`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbSignOff"
              onClick={() => this.handleTabClick(5)}
            >
              Sign Off
            </MotifTabControl>
          </Link>
        </MotifTabNavigation>
        {noReit ? (
          <div className="mt-3">No REITs found for the selected client.</div>
        ) : (
          <OwnershipHeader
            reportPeriods={this.state.reportPeriods}
            handleReportPeriodSelection={this.handleReportPeriodSelection}
            disableAction={this.state.disableAction} // Pass disableAction to the header
            handleExportOwnershipImportTemplate={
              this.handleExportOwnershipImportTemplate
            }
            handleUploadOwnershipImportTemplate={
              this.handleUploadOwnershipImportTemplate
            }
            handleEditOwnershipPercentage={this.handleEditOwnershipPercentage}
            isEditModeActive={this.state.isEditModeActive}
            defaultReportPeriod={this.state.defaultReportPeriod}
          />
        )}

        {noData && !noReit ? (
          <div className="mt-3">
            No REITs found for the selected report period.
          </div>
        ) : (
          !noData &&
          !noReit && (
            <>
              <OwnershipTable
                ownershipData={this.props.ownershipData} // Pass ownershipData correctly
                handleGridChanges={this.handleGridChanges}
                gridColumnState={this.state.gridColumnState}
                gridCurrentState={this.state.gridCurrentState}
                handleGridColumnStateChange={this.handleGridColumnStateChange}
                isEditModeActive={this.state.isEditModeActive}
                toggleGridEditMode={this.toggleGridEditMode}
                gridDataAfterAction={
                  Array.isArray(this.state.gridDataAfterAction)
                    ? this.state.gridDataAfterAction
                    : []
                }
                resetUpdatedRowDataTrigger={
                  this.state.resetUpdatedRowDataTrigger
                }
              />

              {this.state.showUploadOwnershipModal && (
                <UploadOwnershipModal
                  show={this.state.showUploadOwnershipModal}
                  onClose={this.toggleUploadOwnershipModal}
                  reportPeriod={this.state.defaultReportPeriod}
                />
              )}
            </>
          )
        )}
      </div>
    );
  }
}

OwnershipContainer.propTypes = {
  clientId: PropTypes.number,
  periodActions: PropTypes.object,
  propertyActions: PropTypes.object,
  periods: PropTypes.array,
  ownershipData: PropTypes.array,
  ownershipFormValues: PropTypes.object,
};

/**
 * Maps items from state to properties of the component
 * @param {Object} state The state
 * @returns {Object} An object containing properties that the component can access
 */
function mapStateToProps(state, ownProps) {
  let cid = Number.parseInt(ownProps.router.params.clientId);
  if (isNaN(cid)) {
    cid = 0;
  }

  return {
    clientId: cid,
    periods: state.periods,
    ownershipData: state.ownershipData,
    disableAction: state.disableAction,
    selectedReportPeriod: state.selectedReportPeriod,
    isAudit: state.client.isAudit,
    ownershipFormValues: getFormValues('ownershipForm')(state),
  };
}

/**
 * Binds actions to the dispatcher
 * @param {Object} dispatch The action dispatcher
 * @returns {Object} An object containing properties that the component can access
 */
function mapDispatchToProps(dispatch) {
  return {
    periodActions: bindActionCreators(periodActions, dispatch),
    propertyActions: bindActionCreators(propertyActions, dispatch), // Ensure propertyActions is bound correctly
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({
      form: 'ownershipForm',
      enableReinitialize: true,
    })(OwnershipContainer)
  )
);
